import { render, staticRenderFns } from "./relatedArticlesItem.vue?vue&type=template&id=191f7dca&scoped=true&lang=pug&"
import script from "./relatedArticlesItem.vue?vue&type=script&lang=ts&"
export * from "./relatedArticlesItem.vue?vue&type=script&lang=ts&"
import style0 from "./relatedArticlesItem.vue?vue&type=style&index=0&id=191f7dca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191f7dca",
  null
  
)

export default component.exports